import queryString from 'query-string';
import http from '../httpConfig';
import { List, AddEditApi } from '../interfaces/vendor.interface';
import { API_ENDPOINTS } from '../utils/apiConstant';
import { buildPagingResponse } from '../utils/methods';

const list = (payload: List) => {
  const { searchText, serviceTypeId, status, cities, ...others } = payload;
  const paging = buildPagingResponse(others);
  const url = `${API_ENDPOINTS.listVendors}?${queryString.stringify(paging)}`;
  return http.post(url, { search: searchText, service_type_id: serviceTypeId, is_active: status, city_ids: cities });
};

const add = (payload: AddEditApi) => {
  return http.post(API_ENDPOINTS.vendors, payload);
};

const edit = (id: string, payload: AddEditApi) => {
  return http.put(`${API_ENDPOINTS.vendors}/${id}`, payload);
};

const get = (id: string) => {
  return http.get(`${API_ENDPOINTS.vendors}/${id}`);
};

const kpis = () => {
  return http.get(API_ENDPOINTS.vendorListKpis);
};

const lookup = (payload: any) => {
  const url = `${API_ENDPOINTS.lookupVendors}?${queryString.stringify({ search: payload.searchText, is_active: payload.is_active })}`;
  return http.get(url);
};

const serviceTypesLookup = (payload: any) => {
  const url = `${API_ENDPOINTS.serviceTypesLookup}?${queryString.stringify({ search: payload.searchText })}`;
  return http.get(url);
};

const VendorService = {
  list,
  add,
  edit,
  get,
  kpis,
  lookup,
  serviceTypesLookup,
};

export default VendorService;
